import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CourierManagerModalService {

  private selectedCourierManagerSubject = new BehaviorSubject<any>(null);
  public selectedCourierManager$ = this.selectedCourierManagerSubject.asObservable();

  constructor() { }

  setSelectedCourierManager(courierManager: any): void {
    this.selectedCourierManagerSubject.next(courierManager);
  }

  getSelectedCourierManager(): any | null {
    return this.selectedCourierManagerSubject.value;
  }

  clearSelectedCourierManager(): void {
    this.selectedCourierManagerSubject.next(null);
  }
}
